import React, { useState } from "react";
import Accordion from "../faq/accordion";

const FaqSection = ({ data }) => {
  const [selectedItem, setSelectedItem] = useState(null);

  return (
    <div className="w-full px-5 sm:px-10 py-5 sm:py-10" id={data.sectionId}>
      <div className="max-w-7xl w-full mx-auto space-y-3">
        <h2 className="text-center text-2xl sm:text-4xl font-bold flex items-center justify-center">
          {data.leftIcon && (
            <img
              src={data.leftIcon.asset.url || "/placeholder.svg"}
              alt=""
              className="w-9 sm:w-12 h-9 sm:h-12 mr-2 object-contain"
            />
          )}
          {data.title}
          {data.rightIcon && (
            <img
              src={data.rightIcon.asset.url || "/placeholder.svg"}
              alt=""
              className="w-9 sm:w-12 h-9 sm:h-12 ml-2 object-contain"
            />
          )}
        </h2>

        <div className="w-full px-2 mt-5 mb-28 sm:px-0">
          {data.faqs?.map((question, index) => (
            <Accordion
              id={index}
              question={question.question}
              rawAnswer={question?._rawAnswer || question?.answer}
              answer={question.answer}
              key={index}
              selectedItem={selectedItem}
              setSelectedItem={setSelectedItem}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FaqSection;
